import React from "react";
import Navigation from "../../../components/Navigation";
import CreateDomainForm from "./CreateDomainForm/CreateDomainForm";

const CreateDomain = () => {
  return (
    <div className="bg-[#F7F7F7] calc-h-header">
      <Navigation />
      <div className="p-[35px] flex-col justify-start items-start gap-[35px] inline-flex w-full">
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="flex-col justify-start items-start gap-1 inline-flex w-full mr-[20px]">
            <h3 className="text-black text-2xl mb-0 font-semibold font-['Inter'] leading-normal">Add Domain</h3>
            <p className="text-[#747474] mb-0 text-sm font-medium font-['Inter'] leading-[14px]">Add a new domain to your account.</p>
          </div>
        </div>
      </div>
      <CreateDomainForm />
    </div>
  );
};

export default CreateDomain;